import React, { memo } from 'react';
import { useAuthContext } from './providers/AuthProvider';
import { Bars } from 'react-loader-spinner';
import SignIn from './pages/authentication/SignIn';

/**
 * Gates on being logged in, and on nothing else.
 *
 * The `roles` prop is still accepted because ~68 routes pass one, but it is
 * deliberately ignored: the factory's rule is that every role may SEE every
 * page. A salesperson opening the production screens reads real jobs and real
 * numbers; what stops them is the 403 when they press a button, which arrives
 * from middleware/domainAuth.js on the server and is shown as a modal. Hiding
 * the page instead made the application look broken — half the menu missing,
 * with nothing saying why.
 */
const ProtectedRoute = ({ element }) => {
  const [state] = useAuthContext();
  const { isAuthenticated, loading, user } = state;

  // still loading user from token
  if (loading) {
    return (
      <div style={styles.spinnerContainer}>
        <Bars
          height="80"
          width="80"
          color="#3874ff"
          ariaLabel="loading"
        />
      </div>
    );
  }

  // not authenticated — show login
  if (!isAuthenticated || !user) {
    return <SignIn />;
  }

  return element;
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }
};

export default memo(ProtectedRoute);
